import { MediaGroup, MediaGroupTemp } from './types'

export const sortMediaByAsId = (mediaGroup: MediaGroupTemp): MediaGroup =>
  Object.fromEntries(
    Object.entries(mediaGroup).sort(([, a], [, b]): number =>
      !a.group && !b.group ? Number(a.asId) - Number(b.asId) : 0
    )
  )
